/**
 * Cleaning Plan fullscreen covers the site-details drawer and app chrome.
 * Work-interval modals (and their select/time-picker popups) must sit above it.
 */
export const CLEANING_PLAN_FULLSCREEN_Z_INDEX = 1200;
export const WORK_INTERVAL_MODAL_Z_INDEX = 1300;
